enum ReadingPanePosition {
    Off = 0,
    Right = 1,
    Bottom = 2,
    UseGlobal = 3, // A folder with this value indicates that the global reading pane position has to be used.
}

export default ReadingPanePosition;
